export type MemberPlan = {
  plans: [
    {
      planName: string;
      groupNumber: string;
      clientName: string;
      clientNumber: string;
      clientID: string;
      planYear: string;
      planType: string;
      productNumber: string;
      benefitProvider: string;
      integrated: [
        {
          planType: string;
          benefitProvider: string;
        },
      ];
    },
  ];
};

export type ProfileData = {
  demographics: {
    firstName: string;
    lastName: string;
    gender: string;
    dateOfBirth: string;
    memberId: string;
    pin: string;
    relationship: string;
    ecId: string;
    address: AddressData;
    contactPoints: [
      {
        type: string;
        use: string;
        value: string;
      },
    ];
    dependents: [
      {
        firstName: string;
        lastName: string;
        gender: string;
        dateOfBirth: string;
        pin: string;
        relationship: string;
        ecId: string;
      },
    ];
    csPhoneNumber: string;
  };
};

export type EMAIL_VERIFICATION_FLOW = {
  confirmEmail: boolean;
  setConfirmEmail: any;
  handleEditContactClose?: any;
  openEditContact?: boolean;
  openPhoneNumber?: boolean;
  setopenPhoneNumber?: any;
  openEmailAddress: boolean;
  setopenEmailAddress?: any;
  setCpStatus?: any;
  updateContactLoading?: boolean;
  setUpdateContactLoading?: any;
  setAllContactNumber?: any;
  allContactNumber?: any;
  allContactNumberValue?: any;
  setShowPaperlessAlert?: any;
  showPaperlessAlert?: boolean;
  apiFailure?: boolean;
  setApiFailure?: any;
  subscribePhoneSer?: boolean;
  setSubscribePhoneSer?: any;
  handleAlertModalOkBtn?: any;
  phoneType?: string;
  setPhoneType?: any;
  phoneDescription?: string;
  setPhoneDescription?: any;
  alertModalPreSelectedValue?: any;
  setAlertModalPreSelectedValue?: any;
  setOldEmail?: any;
  oldEmail?: any;
  email: string;
  setEmail: any;
  setTextMessage?: any;
  handleCloseSuccess?: any;
  contactData?: any;
  contactDataLoading?: boolean;
  getContactDetails?: any;
  showDiffEmailBtn?: boolean;
  newEmailAdded?: boolean;
  setNewEmailAdded?: any;
};

export type PHONE_VERIFICATION_FLOW = {
  handleEditContactClose?: any;
  openEditContact?: boolean;
  openPhoneNumber?: boolean;
  setopenPhoneNumber?: any;
  setCpStatus?: any;
  updateContactLoading?: boolean;
  setUpdateContactLoading?: any;
  setAllContactNumber?: any;
  allContactNumber?: any;
  allContactNumberValue?: any;
  setShowPaperlessAlert?: any;
  showPaperlessAlert?: boolean;
  setContactDataLoading?: any;
  contactDataLoading?: boolean;
  subscribePhoneSer?: boolean;
  setSubscribePhoneSer?: any;
  textMessage?: boolean;
  phoneType?: string;
  setPhoneType?: any;
  phoneDescription?: string;
  setPhoneDescription?: any;
  alertModalPreSelectedValue?: any;
  setAlertModalPreSelectedValue?: any;
  setOldEmail?: any;
  oldEmail?: any;
  email: string;
  setEmail: any;
  setTextMessage?: any;
  contactData?: any;
  getContactDetails?: any;
  showDiffEmailBtn?: boolean;
};

type AddressData = {
  type: string;
  line1: string;
  line2: string;
  line3: string;
  line4: string;
  city: string;
  state: string;
  postalCode: string;
  countryCode: string;
  county: string;
};

export enum PHONE_NUMBER_TYPE {
  PHONE = 'Phone',
  TEXT = 'Text',
  EMAIL = 'Email',
  OTHERS = 'Other',
}

export enum FORM_TYPE {
  MEDICATION = 'Medication Exception Request Form',
  STEP_THERAPY = 'Step Therapy Exception Request Form',
  DENTAL = 'Member Submitted Dental Claim Form',
  DIRECT_REIMBURSEMENT = 'Direct Reimbursement Claim Form',
  OTHER_INSURANCE = 'Other Insurance Form',
}

export enum FORM_API_TYPE {
  MEDICATION_EXCEPTION = 'medicationexception',
  STEP_THERAPY = 'steptherapy',
  DENTAL_CLAIM = 'dental-claim',
  DIRECT_REIMBURSEMENT_CLAIM = 'direct-reimbursement-claim',
  OTHER_INSURANCE = 'otherinsurance',
}

export enum FORM_OPEN_TYPE {
  PDF_FORM = 'pdf',
  ONLINE_FORM = 'link',
}

export const STATE_VALUE = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MP',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];
